// extracted by mini-css-extract-plugin
module.exports = {"label":"css_label__36nr8","subLabel":"css_subLabel__2qc84"};